import { TreeParameterSugarer } from "./TreeParameterSugarer.js";
import { FieldMarker } from "../../markers/FieldMarker.js";
import { HasOneRelationMarker } from "../../markers/HasOneRelationMarker.js";
import { HasManyRelationMarker } from "../../markers/HasManyRelationMarker.js";
import { EntityListSubTreeMarker } from "../../markers/EntityListSubTreeMarker.js";
import { EntitySubTreeMarker } from "../../markers/EntitySubTreeMarker.js";
import { assertNever } from "../../utils/assertNever.js";
class MarkerSugarer {
  static sugarMarker(marker) {
    if (marker instanceof FieldMarker) {
      return this.sugarFieldMarker(marker);
    }
    if (marker instanceof HasOneRelationMarker) {
      return this.sugarHasOneRelationMarker(marker);
    }
    if (marker instanceof HasManyRelationMarker) {
      return this.sugarHasManyRelationMarker(marker);
    }
    if (marker instanceof EntityListSubTreeMarker) {
      return this.sugarEntityListSubTreeMarker(marker);
    }
    if (marker instanceof EntitySubTreeMarker) {
      return this.sugarEntitySubTreeMarker(marker);
    }
    return assertNever();
  }
  static sugarFieldMarker(field) {
    return TreeParameterSugarer.sugarField(field.fieldName);
  }
  static sugarHasOneRelationMarker(hasOne) {
    return TreeParameterSugarer.sugarHasOneRelation(
      hasOne.parameters.field,
      hasOne.parameters.reducedBy,
      hasOne.parameters.filter
    );
  }
  static sugarHasManyRelationMarker(hasMany) {
    return TreeParameterSugarer.sugarHasManyRelation(hasMany.parameters.field, hasMany.parameters.filter);
  }
  static sugarEntitySubTreeMarker(subTree) {
    if (subTree.parameters.isCreating) {
      return TreeParameterSugarer.sugarRootEntity(subTree.entityName, void 0);
    }
    return TreeParameterSugarer.sugarRootEntity(subTree.entityName, subTree.parameters.where);
  }
  static sugarEntityListSubTreeMarker(subTree) {
    if (subTree.parameters.isCreating) {
      return TreeParameterSugarer.sugarRootEntityList(subTree.entityName, void 0);
    }
    return TreeParameterSugarer.sugarRootEntityList(subTree.entityName, subTree.parameters.filter);
  }
}
export {
  MarkerSugarer
};
//# sourceMappingURL=MarkerSugarer.js.map
